import Flickity from "flickity";
import "flickity-imagesloaded";

export default class Slider {
    constructor(slider) {
        this.config = {
            selectors: {
                slider: ".slider",
                wrapper: ".slider__wrapper",
                btnPrev: ".slider__btn--prev",
                btnNext: ".slider__btn--next",
            },
            classes: {
                active: "is-active",
                ready: "is-ready",
            },
            configDataName: "data-slider",
        };

        window.sliderEls = [];

        this.initSlider(slider);
    }

    initSlider(slider) {
        let sliderEls =
            slider || document.querySelectorAll(this.config.selectors.slider);

        if (!sliderEls) return;

        sliderEls.forEach((el, i) => {
            let _this = this,
                sliderWrapper = el.querySelector(this.config.selectors.wrapper),
                sliderDots = el.querySelector(this.config.selectors.dots),
                sliderBtnPrev = el.querySelector(this.config.selectors.btnPrev),
                sliderBtnNext = el.querySelector(this.config.selectors.btnNext),
                sliderOptions = JSON.parse(
                    el.getAttribute(this.config.configDataName) || false
                ),
                flktyOptions = {
                    prevNextButtons: true,
                    pageDots: false,
                    // cellAlign: "left",
                    imagesLoaded: true,
                    lazyLoad: true,
                    // wrapAround: true,
                    contain: true,
                    groupCells: true,
                    lazyLoad: 4,
                    arrowShape: {
                        x0: 10,
                        x1: 60,
                        y1: 50,
                        x2: 65,
                        y2: 45,
                        x3: 20,
                    },
                    on: {
                        ready: function () {
                            this.element.classList.add(
                                _this.config.classes.ready
                            );
                        },
                    },
                };

            let flkty = new Flickity(sliderWrapper, {
                ...flktyOptions,
                ...sliderOptions,
            });

            window.sliderEls.push(flkty);

            if (!sliderBtnPrev || !sliderBtnNext) return;

            sliderBtnPrev.addEventListener("click", (e) => {
                flkty.previous();
            });

            sliderBtnNext.addEventListener("click", (e) => {
                flkty.next();
            });
        });
    }
}

new Slider();
